define('TescoMobile_Checkout/js/view/choices-modal-insurance',['uiComponent', 'jquery', '../model/insurance', '../action/get-insurances', '../action/check-insurance-perk', '../action/save-family-perk', '../action/save-insurance', '../view/choices-modal-perks', 'Magento_Ui/js/modal/modal', 'Magento_Customer/js/customer-data', 'Magento_Catalog/js/price-utils', 'mage/translate', 'underscore'], function (Component, $, insuranceModel, getInsuranceAction, checkInsurancePerkAction, saveFamilyPerkAction, saveInsuranceAction, choiceModalPerks, modal, customerData, priceUtils, $t, _) {
  'use strict';

  return Component.extend({
    defaults: {
      quoteMask: null,
      insuranceCoverBlock: '',
      insuranceCoverBottomBlock: '',
      insurancePolicyBlock: '',
      insuranceUpgradeBlock: '',
      modalTrigger: null,
      reloadOnSave: false,
      carehubOption: null
    },
    isLoading: true,
    visiblePage: 'selection',
    damageInsurance: null,
    fullInsurance: null,
    noInsurance: null,
    selectedInsuranceSku: null,
    currentInsuranceSku: null,
    hasInsuranceOptions: false,
    insuranceUpdated: false,
    messages: [],
    tableOpen: false,
    modalElement: null,
    replacementCost: null,
    soldAsTraditional: false,
    initialize: function () {
      this._super();
      if (this.carehubOption) {
        var _this$carehubOption, _this$carehubOption2, _this$carehubOption3, _this$carehubOption4;
        this.insuranceCoverBlock = (_this$carehubOption = this.carehubOption) !== null && _this$carehubOption !== void 0 && _this$carehubOption.insuranceCoverBlock ? this.carehubOption.insuranceCoverBlock : this.insuranceCoverBlock;
        this.insuranceCoverBottomBlock = (_this$carehubOption2 = this.carehubOption) !== null && _this$carehubOption2 !== void 0 && _this$carehubOption2.insuranceCoverBottomBlock ? this.carehubOption.insuranceCoverBottomBlock : this.insuranceCoverBottomBlock;
        this.insuranceUpgradeBlock = (_this$carehubOption3 = this.carehubOption) !== null && _this$carehubOption3 !== void 0 && _this$carehubOption3.insuranceUpgradeBlock ? this.carehubOption.insuranceUpgradeBlock : this.insuranceUpgradeBlock;
        this.insurancePolicyBlock = (_this$carehubOption4 = this.carehubOption) !== null && _this$carehubOption4 !== void 0 && _this$carehubOption4.insurancePolicyBlock ? this.carehubOption.insurancePolicyBlock : this.insurancePolicyBlock;
      }
      insuranceModel.quoteMask = this.quoteMask;
    },
    initObservable: function () {
      this._super().observe(['isLoading', 'visiblePage', 'damageInsurance', 'fullInsurance', 'currentInsuranceSku', 'insuranceUpdated', 'noInsurance', 'messages', 'replacementCost', 'soldAsTraditional']);
      return this;
    },
    closeModalNoSave: function (element) {
      if (element.insuranceUpdated == true) {
        element.saveInsurance(false);
      } else {
        $(document).trigger("insuranceClosed");
      }
    },
    setModalElement: function (element) {
      this.modalElement = element;
      var options = {
        type: 'popup',
        innerScroll: true,
        clickableOverlay: false,
        opened: function (a, b) {
          this._updateContent(element);
        }.bind(this),
        closed: function () {
          if (this.getUrlParam('showInsurance', true)) {
            window.history.pushState({}, document.title, window.location.href.split("?")[0]);
          }
        }.bind(this)
      };
      modal(options, $(element));
      if (parseInt(this.lastQuoteItemId) !== 0 && this.hasInsuranceOptions) {
        insuranceModel.quoteItemId = this.lastQuoteItemId;
        $(element).modal('openModal');
        $('body').trigger('insurance-selection');
      } else if (parseInt(this.lastQuoteItemId) !== 0) {
        $('body').trigger('insuranceClosed');
      }
      $(this.modalTrigger).on('click', function (event) {
        var item = $(event.target).parent('div.sub-item');
        insuranceModel.quoteItemId = item.data('quoteItemId');
        $(element).modal('openModal');
        $('body').trigger('insurance-selection');
      }.bind(this));
      $(document).on('insurance-proceed-save', function () {
        this.proceedSaveInsurance();
      }.bind(this));
      $(document).on('insurance-open-modal-event', function () {
        $(element).modal('openModal');
        $('body').trigger('insurance-selection');
      }.bind(this));
      var insuranceParam = this.getUrlParam('showInsurance', true);
      if (insuranceParam) {
        if (insuranceParam !== true && this.checkItemId(insuranceParam)) {
          insuranceModel.quoteItemId = insuranceParam;
        } else {
          insuranceModel.quoteItemId = this.getLastItemId();
        }
        if (insuranceModel.quoteItemId) {
          $(element).modal('openModal');
          $('body').trigger('insurance-selection');
        }
      }
    },
    checkItemId: function (itemId) {
      return $('.insurance-item[data-quote-item-id="' + itemId + '"]').length > 0;
    },
    getLastItemId: function () {
      var quoteData = customerData.get('cart'),
        items = quoteData().items,
        resultItem = false,
        self = this;
      items.forEach(function (item, index) {
        if (self.checkItemId(item.item_id)) {
          resultItem = item.item_id;
        }
      });
      return resultItem;
    },
    getUrlParam: function (type, empty) {
      var getParams = window.location.search;
      if (getParams !== '') {
        var searchParams = new URLSearchParams(getParams.slice(1)),
          value = searchParams.get(type);
        if (empty && value === '') {
          return true;
        }
        return searchParams.get(type) ? searchParams.get(type) : false;
      }
      return false;
    },
    selectInsurance: function (insurance) {
      $(this.modalElement).parent().scrollTop(0);
      if (insurance == false) {
        this.noInsurance(true);
        if (this.currentInsuranceSku()) {
          this.insuranceUpdated = true;
          $('body').trigger('insurance-changed');
          this.selectedInsuranceSku = 'none';
          this.visiblePage('no-insurance');
        } else {
          this.selectedInsuranceSku = 'none';
          this.visiblePage('no-insurance');
        }
        $('body').trigger('insurance-refused');
      } else {
        this.noInsurance(false);
        if (this.currentInsuranceSku() != insurance.sku) {
          this.insuranceUpdated = true;
          $('body').trigger('insurance-changed');
        }
        this.selectedInsuranceSku = insurance.sku;
        this.visiblePage('policy');
        $('body').trigger('insurance-terms');
      }
      return true;
    },
    _updateDivQuoteItemId: function (prevQuoteItemId, quoteItemId, insuranceTitle, insurance) {
      if (prevQuoteItemId && $('.insurance-item[data-quote-item-id="' + prevQuoteItemId + '"]').length) {
        $('.sub-item[data-quote-item-id="' + prevQuoteItemId + '"]').data('quote-item-id', quoteItemId).attr('data-quote-item-id', quoteItemId);
        $('.insurance-item[data-quote-item-id="' + quoteItemId + '"] h5').html(insuranceTitle);
        $('.insurance-item[data-quote-item-id="' + quoteItemId + '"] .sub-text').html(insurance);
      }
    },
    _updateInfoMessagesItemId: function (prevQuoteItemId, quoteItemId) {
      if (prevQuoteItemId && $('.insurance-item[data-quote-item-id="' + prevQuoteItemId + '"]').length) {
        if (!this.noInsurance()) {
          $('.insurance-item[data-quote-item-id="' + quoteItemId + '"] .message.warning.small').hide();
          $('.tariff-info .insurance-item[data-quote-item-id="' + quoteItemId + '"] .insurance-change').hide();
        } else {
          $('.insurance-item[data-quote-item-id="' + quoteItemId + '"] .message.warning.small').show();
          $('.tariff-info .insurance-item[data-quote-item-id="' + quoteItemId + '"] .insurance-change').show();
          $('.tariff-info .insurance-item[data-quote-item-id="' + quoteItemId + '"] > .sub-text').text($t('Phone unprotected'));
        }
      }
    },
    _updatePerksDivQuoteItemId: function (prevQuoteItemId, quoteItemId) {
      if (prevQuoteItemId && $('.family-perks-item[data-quote-item-id="' + prevQuoteItemId + '"]').length) {
        $('.sub-item[data-quote-item-id="' + prevQuoteItemId + '"]').data('quote-item-id', quoteItemId).attr('data-quote-item-id', quoteItemId);
        $('.family-perks-item.sub-item[data-quote-item-id="' + quoteItemId + '"] .sub-text').html('');
      }
    },
    checkInsurancePerk: function () {
      var _self = this,
        deferred = $.Deferred(),
        cartData = customerData.get('cart'),
        dataId = cartData().data_id;
      checkInsurancePerkAction(insuranceModel.quoteItemId, deferred);
      $.when(deferred).done(function (response) {
        if ((!this.selectedInsuranceSku || this.selectedInsuranceSku === 'none') && response) {
          _self.updateFamilyPerk();
        } else {
          $(document).trigger("insuranceSaved", dataId);
          $(document).trigger("insuranceClosed");
        }
      }.bind(this));
    },
    updateFamilyPerk: function () {
      var _self = this,
        deferred = $.Deferred(),
        prevQuoteItemId = insuranceModel.quoteItemId;
      saveFamilyPerkAction(insuranceModel.quoteItemId, 'no_perk', true, deferred);
      $.when(deferred).done(function (response) {
        _self._updatePerksDivQuoteItemId(prevQuoteItemId, insuranceModel.quoteItemId);
      });
    },
    saveInsurance: function () {
      let updated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _self = this,
        prevQuoteItemId = insuranceModel.quoteItemId;
      if (this.insuranceUpdated != true || updated === false) {
        this.visiblePage('selection');
        $(this.modalElement).modal('closeModal');
        $(document).trigger("insuranceClosed");
        return true;
      }
      if (parseInt(this.isCarehub) && this.selectedInsuranceSku !== 'none') {
        $(document).trigger("insurance-proceed-additional-action", this.selectedInsuranceSku);
      } else {
        this.proceedSaveInsurance();
      }
    },
    proceedSaveInsurance: function () {
      var deferred = $.Deferred(),
        _self = this,
        prevQuoteItemId = insuranceModel.quoteItemId;
      deferred.done(function (response) {
        _self._updateDivQuoteItemId(prevQuoteItemId, insuranceModel.quoteItemId, response.insurance_title, response.insurance);
        _self._updateInfoMessagesItemId(prevQuoteItemId, insuranceModel.quoteItemId);
        $(this.modalElement).modal('closeModal');
        this.visiblePage('selection');
        this.checkInsurancePerk();
      }.bind(this)).fail(function (response) {
        this.isLoading(false);
        if (response.message) {
          this.messages([{
            type: 'error',
            text: $.mage.__(response.message)
          }]);
        }
      }.bind(this));
      this.isLoading(true);
      saveInsuranceAction(insuranceModel.quoteMask, insuranceModel.quoteItemId, this.selectedInsuranceSku, deferred);
      return true;
    },
    backToSelection: function () {
      this.visiblePage('selection');
      return true;
    },
    moreLessClick: function () {
      this.tableOpen = !this.tableOpen;
      let insuranceTable = $('.insurance-table');
      if (this.tableOpen) {
        insuranceTable.addClass('open');
        insuranceTable.find('.show-label').text($t('Show less'));
      } else {
        insuranceTable.removeClass('open');
        insuranceTable.find('.show-label').text($t('Show more'));
      }
    },
    _updateContent: function (element) {
      var deferred = $.Deferred();
      this.isLoading(true);
      getInsuranceAction(insuranceModel.quoteMask, insuranceModel.quoteItemId, deferred);
      $.when(deferred).done(function (insurances) {
        this.damageInsurance(insuranceModel.filterByType(insurances, 'accidental'));
        this.fullInsurance(insuranceModel.filterByType(insurances, 'full'));
        this.currentInsuranceSku(insuranceModel.getSelected(insurances));
        this.replacementCost(insuranceModel.getReplacementCost(insurances));
        this.soldAsTraditional(insuranceModel.getIsSoldAsTraditional(insurances));
        this.isLoading(false);
      }.bind(this));
    },
    formatPrice: function (price) {
      return priceUtils.formatPrice(price, this.priceFormat);
    }
  });
});

